import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BookmeLandingPageComponent } from './bookme-landing-page/bookme-landing-page.component';
import { RescheduleConfirmChangesComponent } from './bookme-reschedule/reschedule-confirm-changes/reschedule-confirm-changes.component';
import { RescheduleSuccessComponent } from './bookme-reschedule/reschedule-success/reschedule-success.component';
import { BookmeComponent } from './bookme/bookme.component';
import { CancelConfirmationPageComponent } from './cancel-confirmation/cancel-confirmation.component';
import { CancelInfoPageComponent } from './cancel-info/cancel-info.component';
import { LegacyRedirectGuard } from './legacy-redirect-guard.service';
import { MeetingInfoPageComponent } from './meeting-info/meeting-info.component';
import { BookingLayoutComponent } from './booking-layout/booking-layout.component';

const routes: Routes = [
  {
    path: 'service/:serviceId/:serviceSlug',
    component: BookingLayoutComponent,
  },
  {
    path: 'group/:groupId/:groupSlug',
    component: BookingLayoutComponent,
  },
  {
    path: 'book/:calendarId/:meetingTypeId',
    component: BookingLayoutComponent,
  },
  {
    path: 'book/:calendarId',
    redirectTo: ':calendarId',
  },
  {
    path: 'cancels/:calendarId/:meetingId',
    redirectTo: 'cancel-info/:meetingId',
    pathMatch: 'full',
  },
  {
    path: 'reschedules/:calendarId/:meetingId/confirm-changes',
    component: BookmeComponent,
    children: [{ path: '', component: RescheduleConfirmChangesComponent }],
  },
  {
    path: 'reschedules/:calendarId/:meetingId',
    component: BookingLayoutComponent,
    data: { mode: 'reschedule' },
  },
  {
    path: 'meeting-info/:meetingId',
    component: BookmeComponent,
    children: [{ path: '', component: MeetingInfoPageComponent }],
  },
  {
    path: 'cancel-info/:meetingId',
    component: BookmeComponent,
    children: [
      { path: '', component: CancelInfoPageComponent },
      { path: 'cancelled', component: CancelConfirmationPageComponent },
    ],
  },
  {
    path: 'reschedule-info/:meetingId',
    component: BookmeComponent,
    children: [{ path: '', component: RescheduleSuccessComponent }],
  },
  // Session routes - no host required, direct loading
  {
    path: 'session',
    loadChildren: () =>
      import('./session/session.module').then((m) => m.SessionModule),
  },
  // Public meeting sharing routes - must be before :calendarId catch-all
  {
    path: 'meeting/:namespaceID/:publicId',
    component: BookmeComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./shared-meeting-page/shared-meeting-page.component').then(
            (m) => m.SharedMeetingPageComponent,
          ),
      },
    ],
  },
  // Old public meeting sharing routes
  {
    path: 'video/:namespaceID/:publicId',
    component: BookmeComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./shared-meeting-page/shared-meeting-page.component').then(
            (m) => m.SharedMeetingPageComponent,
          ),
      },
    ],
  },
  {
    path: ':calendarId',
    component: BookingLayoutComponent,
  },

  {
    path: '',
    pathMatch: 'full',
    component: BookmeLandingPageComponent,
    canActivate: [LegacyRedirectGuard],
    canActivateChild: [LegacyRedirectGuard],
  },

  // TODO: The below routes will redirect traffic from legacy routes.
  {
    path: 'reschedules/:meetingId',
    component: BookmeComponent,
    canActivate: [LegacyRedirectGuard],
    canActivateChild: [LegacyRedirectGuard],
  },
  {
    path: 'cancels/:meetingId',
    component: BookmeComponent,
    canActivate: [LegacyRedirectGuard],
    canActivateChild: [LegacyRedirectGuard],
  },
  {
    path: 'terms',
    loadChildren: () =>
      import('./terms/terms.module').then((m) => m.TermsModule),
  },
  // TODO: Not sure if these redirects are required by Google Auth in Meeting Scheduler.
  {
    path: 'privacy-policy',
    redirectTo: 'terms/privacy-policy',
    pathMatch: 'full',
  },
  {
    path: 'terms-of-service',
    redirectTo: 'terms/terms-of-service',
    pathMatch: 'full',
  },
  {
    path: 'privacy-policy/third-party-subprocessors',
    redirectTo: 'terms/third-party-subprocessors',
    pathMatch: 'full',
  },
  {
    path: 'privacy-policy/data-processing-addendum',
    redirectTo: 'terms/data-processing-addendum',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
